const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const validateDisplayName = (value) => value.trim().length === 0 ? 'fieldRequired' : undefined;
export const validateEmail = (value) => {
    if (value.trim().length === 0)
        return 'fieldRequired';
    return EMAIL_REGEX.test(value.trim()) ? undefined : 'invalidEmail';
};
export const validateRoles = (roles) => roles.length === 1 ? undefined : 'fieldRequired';
export const validateConfirmPassword = (password, confirmPassword) => {
    if (!password)
        return undefined;
    return password === confirmPassword ? undefined : 'passwordsDoNotMatch';
};
export const validateField = (field, values) => {
    switch (field) {
        case 'displayName':
            return validateDisplayName(values.displayName);
        case 'email':
            return validateEmail(values.email);
        case 'roles':
            return validateRoles(values.roles);
        case 'confirmPassword':
            return validateConfirmPassword(values.password, values.confirmPassword);
    }
};
export const validateAgentForm = (values) => ({
    displayName: validateDisplayName(values.displayName),
    email: validateEmail(values.email),
    roles: validateRoles(values.roles),
    confirmPassword: validateConfirmPassword(values.password, values.confirmPassword),
});
export const hasAnyError = (errors) => Object.values(errors).some((v) => !!v);
